import { render, staticRenderFns } from "./MoveHomePage.vue?vue&type=template&id=833649d8&"
import script from "./MoveHomePage.vue?vue&type=script&lang=js&"
export * from "./MoveHomePage.vue?vue&type=script&lang=js&"
import style0 from "./MoveHomePage.vue?vue&type=style&index=0&id=833649d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports